import { onBeforeUnmount, onMounted, toValue } from 'vue';
import { updateSportLiveTvPosition } from '@/api/sport-live-tv';
import { SPORT_LIVE_TV_POSITION_INTERVAL_MS } from '@/sport-live-tv/constants';

export const useSportLiveTvPosition = (eventId) => {
  let currentSeconds = 0;
  let timerId = null;

  const trackTime = (seconds) => {
    currentSeconds = seconds;
  };

  const sendPosition = () => {
    const id = toValue(eventId);
    if (!id || currentSeconds <= 0) return;

    updateSportLiveTvPosition(id, currentSeconds).catch(() => {});
  };

  onMounted(() => {
    timerId = setInterval(sendPosition, SPORT_LIVE_TV_POSITION_INTERVAL_MS);
  });

  onBeforeUnmount(() => clearInterval(timerId));

  return { trackTime };
};
